import { DatePicker } from "@arco-design/web-react";
import { ArrowRight } from "lucide-react";
import type { ReactNode } from "react";
import type { RailwayPurpose } from "../../railway-query/types";

type Props = {
  origin: ReactNode; destination: ReactNode; date: string; minDate: string; maxDate: string;
  queryDisabled: boolean; loading: boolean; onDateChange: (date: string) => void; onQuery: () => void;
  purpose?: RailwayPurpose; onPurposeChange?: (purpose: RailwayPurpose) => void;
};

/** 行程内直达与中转共用查询栏；不支持的查询能力明确置灰，不能静默提交其他条件。 */
export function ItineraryRailwaySearchBar({ origin, destination, date, minDate, maxDate,
  queryDisabled, loading, onDateChange, onQuery, purpose = "ADULT", onPurposeChange }: Props) {
  return <div className="railway-query-scroll itinerary-railway-search"><div className="railway-query-content"><form className="rail-search" onSubmit={(event) => { event.preventDefault(); if (!queryDisabled) onQuery(); }}>
    <div className="rail-trip-radio" role="group" aria-label="行程类型">
      <label><input type="radio" checked readOnly />单程</label>
      <label title="返程请在对应行程路线中选择"><input type="radio" disabled />往返</label>
    </div>
    <div className="rail-search-fields">
      <div className="rail-field itinerary-railway-station"><span>出发地</span>{origin}</div>
      <span className="rail-swap" title="路线方向由行程骨架确定"><ArrowRight size={22} /></span>
      <div className="rail-field itinerary-railway-station"><span>目的地</span>{destination}</div>
      <label className="rail-field"><span>出发日</span><DatePicker value={date} allowClear={false}
        inputProps={{ "aria-label": "出发日期", onBlur: (event) => {
          const value = event.currentTarget.value.trim(); if (/^\d{4}-\d{2}-\d{2}$/.test(value)) onDateChange(value);
        } }} onChange={onDateChange} disabledDate={(value) => value.format("YYYY-MM-DD") < minDate || value.format("YYYY-MM-DD") > maxDate}
        style={{ width: 132, background: "white", border: "1px solid #cecece", borderRadius: 0 }} /></label>
      <label className="rail-field rail-disabled"><span>返程日</span><DatePicker disabled placeholder="返程日期"
        style={{ width: 132, background: "white", border: "1px solid #cecece", borderRadius: 0 }} /></label>
    </div>
    <div className="rail-purpose" role="group" aria-label="旅客类型">
      <label><input type="radio" name="itinerary-rail-purpose" checked={purpose === "ADULT"} readOnly={!onPurposeChange}
        onChange={() => onPurposeChange?.("ADULT")} />普通</label>
      <label title={onPurposeChange ? undefined : "中转暂不支持学生票查询"}><input type="radio" name="itinerary-rail-purpose"
        checked={purpose === "0X00"} disabled={!onPurposeChange} onChange={() => onPurposeChange?.("0X00")} />学生</label>
    </div>
    <button type="submit" className="rail-query-button" disabled={queryDisabled}>{loading ? "查询中…" : "查询"}</button>
  </form></div></div>;
}
